import Header from '../../header/Header';
import Footer from '../../footer/Footer';
import style from './style';
import { useEffect } from 'preact/hooks';

const Home = ({ handleSiteChange, setOverlay, site, loadedImages, overlayVisible, closeOverlay }) => {
	useEffect(() => {
		history.pushState("", document.title, window.location.pathname + window.location.search);
	}, []);
	
	return (
		<div id={'site-0'} class={style.home}>
			<Header
				site={site}
				setOverlay={setOverlay}
				overlayVisible={overlayVisible}
				closeOverlay={closeOverlay}
			/>
			<img src={'https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/hero.png'}/>
			<video autoPlay muted loop poster='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/home-poster.jpg'>
				<source src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/home.mp4' type='video/mp4'/>
			</video>

			<a
				activeClassName={style.active}
				class={style.link}
				onClick={() => handleSiteChange(1, false, loadedImages)}
			>
				Погрузись!
			</a>
            <a  class={`${style['link--small']}`} onClick={(e) => setOverlay(e, 'episodes')}>или выбери эпизод</a>
			<Footer/>
		</div>
	)
};

export default Home;
